import axios from 'axios';

const baseUrl = '/keyword-analysis';

export default {
  getKeywordAnalysisForJob(jobId) {
    return axios.get(`${baseUrl}/for-job/${jobId}`);
  },
};
